import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Tooltip from '@mui/material/Tooltip'
import ClickAwayListener from '@mui/material/ClickAwayListener'

const LearnMore = ({
  buttonText,
  tooltipText,
  TooltipProps,
  IconProps,
  size,
  ...props
}) => {
  const [open, setOpen] = useState(false)

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipOpen = () => {
    setOpen(!open)
  }

  return (
    <Box
      display="inline-grid"
      justifyContent="flex-start"
    >
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <Tooltip
          title={tooltipText}
          {...TooltipProps}
          arrow
          open={open}
          disableHoverListener
          disableFocusListener
          disableTouchListener
          onClose={handleTooltipClose}
          onOpen={handleTooltipOpen}
        >
          <Box
            sx={{
              cursor: 'pointer',
              display: 'inline-flex',
              justifyContent: 'flex-start',
              maxWidth: 'max-content',
            }}
            {...props}
            onClick={handleTooltipOpen}
          >
            <Link color="secondary.main">
              {buttonText}
            </Link>
          </Box>
        </Tooltip>
      </ClickAwayListener>
    </Box>
  )
}

LearnMore.propTypes = {
  TooltipProps: PropTypes.object,
  tooltipText: PropTypes.string.isRequired,
  IconProps: PropTypes.object,
  size: PropTypes.oneOf(['default', 'lg']),
}

LearnMore.defaultProps = {
  TooltipProps: {},
  tooltipText: '',
  IconProps: {},
  size: 'default',
}

export default LearnMore
